export const Colon = () => <span className="DsPreviewJson-Colon">: </span>;
